import React, { useEffect, useState } from "react";
import ActionPlaybook from "../default/components/ActionPlaybook";
import { useInterval } from "contexts/IntervalContext";
import { fetchDashboardActions } from "api/dashboardActions";

export default function ActionsPage() {
  const { interval } = useInterval();
  const [actions, setActions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadActions = async () => {
    try {
      setIsLoading(true);
      const data = await fetchDashboardActions(interval);
      setActions(data);
    } catch (err) {
      console.error("Failed to fetch actions:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadActions();
  }, [interval]);

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Action Playbook
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Actions recommended based on your forecast and demand signals.
        </p>
      </div>

      <ActionPlaybook
        title={`Actions (${interval})`}
        subtitle={`Prioritised steps to maximise profit this ${interval} period`}
        items={actions}
        onRefresh={loadActions}
        isLoading={isLoading}
      />
    </div>
  );
}